module.exports = __webpack_public_path__ + "static/media/car-wash.b89b04a9.svg";